import { Box, Text } from '@wix/design-system';
import { ResourceSection } from '@wix/wix-help-widget-common/homepage';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback, useMemo } from 'react';

import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import s from '../styles.scss';
import { mapResourceIdToContent } from './mapResourceIdToContent';

export type ExternalResourcesItemProps = Readonly<{
  index: number;
  blockPositionIndex: number;
  resourceSection: ResourceSection;
}>;

export const ExternalResourcesItem: FC<ExternalResourcesItemProps> = ({
  index,
  blockPositionIndex,
  resourceSection,
}) => {
  const { t } = useTranslation();
  const {
    IconComponent,
    titleKey,
    descriptionKey,
    href,
    dataHook,
    target,
  } = useMemo(() => mapResourceIdToContent[resourceSection.resourceId], [
    resourceSection,
  ]);
  const title = resourceSection.title ?? t<TLocalesKeys>(titleKey);
  const description =
    resourceSection.content ?? t<TLocalesKeys>(descriptionKey);

  const onClick = useCallback(
    () =>
      biHelpCenter.logHelpResourcesButtonInteraction(
        href,
        title,
        index,
        blockPositionIndex,
      ),
    [href, title, index, blockPositionIndex],
  );

  return (
    <a
      className={s.homepageActionItem}
      href={href}
      onClick={onClick}
      target={target ?? '_blank'}
      rel="noreferrer"
      data-hook={dataHook}
    >
      <Box padding="18px" direction="vertical">
        <Box verticalAlign="middle" gap="8px">
          <IconComponent fill="#116DFF" />
          <Text weight="normal">{title}</Text>
        </Box>
        <Text size="small" secondary>
          {description}
        </Text>
      </Box>
    </a>
  );
};
